import(/* webpackMode: "eager", webpackExports: ["RustoreOpen"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/RustoreOpen/RustoreOpen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["onSocialClick","onFooterClick"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/StrapiFooter/onClickHandlers.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/StrapiHeader/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwitchLanguageComponent"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/SwitchLanguageComponent/SwitchLanguageComponent.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageLayout.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageViewLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/builds/RuStore-Web/monoland/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppCard"] */ "/builds/RuStore-Web/monoland/packages/shared/AppCard/AppCard.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NotFound/assets/404.webp");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NotFound/NotFound.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/dzen.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/mir.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/mobile.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/odnoklassniki.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/sber.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/sbp.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/tinkoff.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/ula.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/vk-cloud.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/vk-mail.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/strapi/endpoints/DevLanding/DevLanding/assets/vk.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/ui-kit/src/Footer/components/LeftSideBlock/LeftSideBlock.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Sections"] */ "/builds/RuStore-Web/monoland/packages/ui-kit/src/Footer/components/Sections/Sections.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/ui-kit/src/Footer/Footer.module.scss");
